export const FORM_DATA = {
  transaction: "All Transactions",
  subscription: "Manage Subscriptions",
  refundHistory: "Refund History",
  disputeHistory: "Dispute History",
};
